import { Component, input } from '@angular/core';
import { AppIntegration } from "./DashboardIntegrations";

@Component({
  selector: 'IntegrationStatus',
  imports: [],
  template: `
    <div class="{{ containerClass() }}">
      @if (integration().status === 'trial-running' || integration().status === 'trial-ended') {
        <p class="mb-0 text-xs font-extrabold font-mark-heavy {{
          integration().status === 'trial-ended' ? 'text-red-500' : 'text-blue-500'
        }} {{ leadingClass() }}"
        >
          {{ integration().trialMessage }}
        </p>
      }
      <p class="{{ messageClass() + ' ' + leadingClass() }}" [innerHTML]="integration().message"></p>
    </div>
  `,
})
export class IntegrationStatus {
  containerClass = input('');
  integration = input.required<AppIntegration>();
  leadingClass = input('');
  messageClass = input('text-xs');
}
